
const cfgWeapons = [
  "M16", 
  "M16GrenadeLauncher", 
  "M4", 
  "XMS",
  "AK47", 
  "AK47GrenadeLauncher", 
  "AK47CZ", 
  "AK74", 
  "AK74GrenadeLauncher", 
  "AK74SU", 
  "HK", 

  "HKG3",
  "G36a",
  "Steyr",

  "M21", 
  "SVDDragunov", 
  "HuntingRifle",
  "Kozlice",
  "M60", 
  "PK", 

  "Beretta",
  "CZ75",
  "Glock",
  "GlockS",
  "Ingram",
  "Revolver",
  "Skorpion",
  "Tokarev",
  "UZI",

  "MM1",
  "6G30",

  "LAWLauncher", 
  "RPGLauncher", 
  "CarlGustavLauncher", 
  "AT4Launcher", 
  "AALauncher", 
  "9K32Launcher", 
  "AT3Launcher",

  "LaserDesignator",

  "Binocular", 
  "NVGoggles", 
];

export default cfgWeapons;